import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import Grid from 'styled-components-grid';

import { py, ml } from 'styled-components-spacing';

import { StyledCoverMaxWidthPadding as StyledCoverMaxWidthPaddingOriginal } from '@components/Wrappers';
import { StyledHeadlineTextSectionBright } from '@components/Headlines/styles';

import { linkButtonTransparentBright } from '@styles/links';
import theme from '@theme';
import { SvgChevronRight } from '@images/svg';

const { colors } = theme;
const { gradients } = theme;

export const StyledCover = styled.div`
  ${py(1)};
  ${gradients.linearBlueTurquoiseLTR}
  background: ${props => (props.color ? props.color : gradients.linearBlueTurquoiseLTR)};
  padding-top: ${props => (props.homePage ? '0px' : '50px')};
  justify-content: center;
  align-items: center;
  ${breakpoint('desktop', 'tablet')`
    padding-left: 5%;
    padding-right: 5%;
    height: 50%;
 `}
  ${breakpoint('mobile', 'tablet')`
    height: 50%;
    padding-left: 1%;
    padding-right: 1%;
  `}
`;

export const StyledGrid = styled(Grid)`
${({ py }) => py && 'padding: 20px 0px'};
  ${breakpoint('desktop')`
   ${({ dmb }) => dmb && 'margin-bottom: 40px'};
 `}

  ${breakpoint('tablet', 'desktop')`
   ${({ tmb }) => tmb && 'margin-bottom: 30px'};
 `}

${breakpoint('mobile', 'tablet')`
   ${({ mmb }) => mmb && 'margin-bottom: 20px'};
 `}
`;

export const StyledGridUnit = styled(Grid.Unit)`

${({ flex }) => flex && 'display: flex'};
  ${({ column }) => column && 'flex-direction: column'};
  ${({ center }) => center && 'justify-content: center'};
  ${({ p }) => p && 'padding: 20px'};
  ${({ brw }) => brw && 'border-right: 2px solid white'};

  ${breakpoint('desktop')`
   ${({ dpl }) => dpl && 'padding-left: 30px'};
   ${({ dpt }) => dpt && 'padding-top: 30px'};
   ${({ p }) => p && 'padding: 15px'};
`}

${breakpoint('tablet', 'desktop')`
${({ p }) => p && 'padding: 15px'};
   ${({ tpl }) => tpl && 'padding-left: 30px'};
   ${({ tpt }) => tpt && 'padding-top: 30px'};
`}

  ${breakpoint('mobile', 'tablet')`
  ${({ p }) => p && 'padding: 10px'};
   ${({ mpl }) => mpl && 'padding-left: 10px'};
   ${({ mpt }) => mpt && 'padding-top: 10px'};
   ${({ mptx }) => mptx && 'padding-top: 30px'};
`}
`;

export const StyledLinkMore = styled.a`
  ${linkButtonTransparentBright}
  margin-bottom: 10px;
  padding: 0.5rem;
  border: none;
  font-style: normal;
  font-weight: 300;
  line-height: 44px;
  text-align: center;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  ${breakpoint('desktop')`
    font-style: normal;
    font-weight: 600;
    padding: 0.5rem;
    height: 35px;
    font-size: 18px;
    line-height: 44px;
    text-align: center;
    display: flex;
    position: relative;
    left: 9px;
    padding-left: 25px !important;
    padding-right: 25px !important;
  `}
  ${breakpoint('mobile', 'tablet')`
    border-radius: 12px;
    color: ${colors.warmGray} !important;
    font-weight: bold;
    font-size: 17px;
    height: 25px;
    background-color: white
    justify-content: center;
    align-items : center;
    background: #ffffff;
    border-radius: 25px;
    width: 70px;
    padding-left: 25px;
    padding-right: 25px;
    padding-top: 10px ;
    padding-bottom: 10px ;
  @media only screen and (max-width: 390px) {
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 9px;
    font-size: 17px;
    height: 14px;
  }
  @media only screen and (max-width: 300px) {
    padding-left: 10px;
    padding-right: 10px ;
    padding-top: 7px ;
  }
  `}
  
  ${breakpoint('tablet', 'desktop')`
    font-weight: 600;
    font-size: 18px;
    line-height: 44px;
    padding-left: 26px;
  `}
  
`;

export const StyledCoverLinkMore = styled.div`
  display: flex;
  align-items: center;

  ${breakpoint('desktop', 'tablet')`
    height: 30px;
    padding-top: 20px;
  `}
  ${breakpoint('mobile', 'tablet')`
    padding-top: 20px;
    @media only screen and (max-width: 300px) {
    height: 12px;
  }
  `}
`;

export const StyledCoverTopMaxWidthPadding = styled(StyledCoverMaxWidthPaddingOriginal)`
  margin-bottom: 30px !important;
`;

export const StyledCoverMaxWidthPadding = styled(StyledCoverMaxWidthPaddingOriginal)`
 display: flex;
 width: 50%;
 height: 300px;
 display: flex;
 justify-content: space-between;
 margin-bottom: 60px !important;
 ${breakpoint('desktop', 'tablet')`
   display: flex;
   margin-left: 20px;
   width: auto%;
   height: 250px;
  `}
  ${breakpoint('mobile', 'tablet')`
    width: auto!important ;
    display: flex;
    display: flex;
    flex-direction: column-reverse;
    height: 500px;
    margin-top:5px;
    font-size: 20px;
  `}
   ${breakpoint('tablet')`
     width: 102% !important ;
     height: auto;
     margin-top: 5px;
     padding-left: 2%;
     font-size: 20px;
     justify-content: center;
     align-items: center;
  `}
`;

export const StyledFaqWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

export const StyledCoverMain = styled.div`
  width: 100%;
  height: 300px;
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: center;
  ${breakpoint('mobile', 'tablet')` 
    display: flex;
    width: 70%;
    flex-direction: column-reverse;
    height: 600px;
  `}
`;

export const StyledParentIconImage = styled.div`
  width: 500px;
  ${breakpoint('tablet')`
    width: 450px;
    height: auto;
 `}
`;
export const StyledIconImage = styled.img`
  ${breakpoint('mobile', 'tablet')`
   width: 200px;
 `}

  ${breakpoint('tablet')`
   width: 200px;
 `}

  ${breakpoint('desktop')`
   flex: 1;
   max-width: 350px;
   max-height: 450px;
 `}

`;

export const StyledIcon = styled(SvgChevronRight)`
  ${ml(3)}
  height: 16px;
  width: 10px;
  ${breakpoint('mobile', 'tablet')`
    display: none;
  `}
  g {
    fill: ${theme.colors.white};
  }
  flex: 0 0 auto;
`;

export const StyledSubHeadlineText = styled.div`
  color: ${colors.white} !important ;
  font-weight: 700;
  margin-bottom: 10px;
  max-width: 1200px !important;
  ${breakpoint('tablet')`
    font-size: 40px;
    margin-left: 0px;
   `}
  ${breakpoint('desktop')`
    color:pink;
    font-size: 40px;
   `}
  ${breakpoint('mobile')`
    margin-bottom:0px;
    font-size: 22px ;
    margin-left: 10px;
  @media only screen and (max-width:390px) {
  {
    justify-content: center;
    justify-content: center;
    font-size: 20px ;
    font-wight: 15px;
    max-width: auto;
    height: auto;
    dispaly: flex;
    flex-direction: row;
  }
  `} 
`;
export const StyledHeadlineTextOne = styled(StyledHeadlineTextSectionBright)`
  padding-left: 1.5rem;
  ${breakpoint('mobile')`
    display: none;
  `}
  ${breakpoint('tablet')`
    font-size: 25px;
    display: flex;
    padding-left:0px;
  `}
   ${breakpoint('desktop')`
     display: flex;
     font-size: 25px;
     font-weight: bold;
    `}
`;
